import { Link, useMatch, useResolvedPath } from "react-router-dom";

export default function MenuItem({ menu }: any) {
  const { to, icon, name } = menu;
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: false });

  return (
    <div
      className={`flex  justify-center items-center mr-2 sm:mr-4 text-auto-xxs ${
        match ? "" : ""
      }`}
    >
      <Link to={to}>
        <div className="flex justify-center items-center">
          <div
            className={`flex justify-center items-center bg-toyota rounded-lg ${
              match ? "bg-toyota-pale " : "bg-toyota-dark"
            }`}
          >
            <div className={`text-gray-400 ${match ? "text-gray-700" : "text-gray-400"}`}>{icon}</div>
          </div>
          <div className={`uppercase ml-1 font-bold text-xs ${match ? "text-gray-700" : "text-gray-400"}`}>
            {name}
          </div>
        </div>
      </Link>
    </div>
  );
}